import { cacheRequest } from '@/base/MaRequestPooler.js'

export function fetchAudienceGeographySummary({ trackId }) {
  return cacheRequest(`/market-estimation/audience-geography/${trackId}`)
}
